'use strict';

const jsxRuntime = require('react/jsx-runtime');
const React = require('react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const components_display_Text_Text = require('../../display/Text/Text.cjs.js');
const components_display_TooltipWrapper_TooltipWrapper = require('../../display/TooltipWrapper/TooltipWrapper.cjs.js');
const components_navigation_PageNavigation_PageNavigationRow = require('./PageNavigationRow.cjs.js');
const components_navigation_PageNavigation_utils_checkIsTruncated = require('./utils/checkIsTruncated.cjs.js');

const textEllipsis = "_text-ellipsis_1osdn_1";
const textWrap = "_text-wrap_1osdn_8";
const rowContainer = "_row-container_1osdn_17";
const styles = {
	textEllipsis: textEllipsis,
	textWrap: textWrap,
	rowContainer: rowContainer
};

function NestedThirdRow({ item, onSelect }) {
  const [isTruncated, setIsTruncated] = React.useState(false);
  const textRef = React.useRef(null);
  React.useEffect(() => {
    setIsTruncated(components_navigation_PageNavigation_utils_checkIsTruncated(textRef));
  }, []);
  const InnerContent = ({ hover, selected }) => {
    const textColor = hover || selected ? "UiPrimaryStrongest" : "GrayWarm10";
    const textType = selected ? "Body3" : "Body2";
    return jsxRuntime.jsx("div", { className: styles.rowContainer, "data-zds": true, children: jsxRuntime.jsx("span", { className: styles.textWrap, "data-zds": true, children: jsxRuntime.jsx("span", { className: styles.textEllipsis, style: { "--_zds-nestedthirdrow-textcolor": theme_Colors.Colors[textColor] }, ref: textRef, "data-zds": true, children: jsxRuntime.jsxs(components_display_Text_Text.Text, { color: textColor, margin: "0 0 0 8px", type: textType, children: [item.title, item.count && ` (${item.count})`] }) }) }) });
  };
  const Content = ({ hover, selected }) => isTruncated ? jsxRuntime.jsx(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { allowMultilineTooltip: true, content: item.count ? `${item.title} (${item.count})` : item.title, isBlock: true, position: "northeast", children: () => jsxRuntime.jsx(InnerContent, { hover, selected }) }) : jsxRuntime.jsx(InnerContent, { hover, selected });
  return jsxRuntime.jsx(components_navigation_PageNavigation_PageNavigationRow, { content: Content, item, onSelect });
}

module.exports = NestedThirdRow;
//# sourceMappingURL=NestedThirdRow.cjs.js.map
